import { Dialog, IconButton, Menu, MenuItem } from "@material-ui/core";
import classnames from "classnames";
import * as React from "react";
import { connect } from "react-redux";
import CloseIcon from "src/documentUpload/close.svg";
import QuiqButton from "src/shared/QuiqButton";
import { isRequesting, transitionIfFinished } from "../requestProgress/helpers";
import { actions } from "../requestProgress/reducer";
import { getRequestProgress } from "../requestProgress/selector";
import WarningIcon from "../spread/chartOfAccounts/warning-icon.svg";
import selectorsToProps from "../utils/selectorsToProps";
import {
  deleteSpread,
  DeleteSpreadActionType,
  DeleteSpreadParams,
  reloadBriefSpreads,
  ReloadBriefSpreadsActionType
} from "./actions";
import { MoreVerticalIcon } from "./MoreVerticalIcon";
import { BriefSpread } from "./types";

interface MoreOptionsState {
  isMoreClicked: boolean;
  isModalOpen: boolean;
  anchorEl: HTMLElement | null;
  isFinishedDeleting: boolean;
}

interface MoreOptionsProps {
  document: BriefSpread;
  deleteSpread: DeleteSpreadActionType;
  isDeletable: boolean;
  reloadBriefSpreads: ReloadBriefSpreadsActionType;
}

export class MoreOptions extends React.Component<
  MoreOptionsProps,
  MoreOptionsState
> {
  constructor(props: MoreOptionsProps) {
    super(props);
    this.state = {
      isModalOpen: false,
      isMoreClicked: false,
      anchorEl: null,
      isFinishedDeleting: false
    };
  }

  public componentWillReceiveProps() {
    const deleteInProgress = !this.state.isFinishedDeleting;

    if (deleteInProgress) {
      const isFinishedState = transitionIfFinished(actions.deleteSpread);
      if (isFinishedState && isFinishedState.finished) {
        this.props.reloadBriefSpreads();
        this.setState({ isFinishedDeleting: true });
      }
    } else {
      const isFinishedState = transitionIfFinished(actions.reloadBriefSpreads);
      if (isFinishedState && isFinishedState.finished) {
        this.closeModal();
      }
    }
  }

  public closeModalWithEvent = (event: React.SyntheticEvent<{}, Event>) => {
    event.stopPropagation();
    this.setState({ isModalOpen: false });
  };

  public openModal = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    this.setState({ isModalOpen: true });
  };

  public closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  public openMore = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    this.setState({
      isMoreClicked: !this.state.isMoreClicked,
      anchorEl: event.currentTarget
    });
  };

  public closeMoreWithEvent = (event: React.SyntheticEvent<{}, Event>) => {
    event.stopPropagation();
    this.setState({ isMoreClicked: false, anchorEl: null });
  };

  public closeMore = () => {
    this.setState({ isMoreClicked: false, anchorEl: null });
  };

  public deleteSpreadHandler = () => {
    const params: DeleteSpreadParams = {
      spreadId: this.props.document.spreadId
    };
    this.props.deleteSpread(params);
  };

  public stopPropagation = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  };

  public render() {
    const { isMoreClicked, isModalOpen, anchorEl } = this.state;
    const isDeleting = isRequesting(actions.deleteSpread);

    return (
      <div className="MoreOptions">
        <IconButton
          className={classnames("MoreOptions__button", {
            "MoreOptions__button--open": isMoreClicked
          })}
          onClick={this.openMore}
        >
          <MoreVerticalIcon />
        </IconButton>

        <div className="MoreOptions__actions">
          {this.props.isDeletable && (
            <Menu
              open={isMoreClicked}
              anchorEl={anchorEl}
              onClose={this.closeMoreWithEvent}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              getContentAnchorEl={null}
            >
              <MenuItem
                className="MoreOptions__actions__openModal"
                onClick={this.openModal}
              >
                Delete spread
              </MenuItem>
            </Menu>
          )}
        </div>

        <Dialog
          open={isModalOpen}
          onEnter={this.closeMore}
          onClose={this.closeModal}
          PaperProps={{ className: "DeleteSpreadModal" }}
          disableBackdropClick={true}
          disableEscapeKeyDown={true}
          onBackdropClick={this.stopPropagation}
          onClick={this.stopPropagation}
          transitionDuration={0}
        >
          <img
            src={CloseIcon}
            className="DeleteSpreadModal__closing-icon"
            onClick={this.closeModal}
          />
          <img src={WarningIcon} className="DeleteSpreadModal__warning-icon" />
          <div className="DeleteSpreadModal__header">Delete Spread</div>
          <div className="DeleteSpreadModal__text">
            This change is permanent and cannot be undone.
          </div>
          <div className="DeleteSpreadModal__actions">
            <QuiqButton
              variant="text"
              className="DeleteSpreadModal__actions__cancel"
              onClick={this.closeModalWithEvent}
              isDisabled={isRequesting(actions.deleteSpread)}
            >
              Cancel, keep spread
            </QuiqButton>
            <QuiqButton
              color="blue"
              className="DeleteSpreadModal__actions__delete"
              isLoading={isDeleting}
              onClick={this.deleteSpreadHandler}
            >
              Yes, Delete Spread
            </QuiqButton>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default connect(
  selectorsToProps({
    requestProgress: getRequestProgress
  }),
  {
    deleteSpread: deleteSpread.action,
    reloadBriefSpreads: reloadBriefSpreads.action
  }
)(MoreOptions);



// WEBPACK FOOTER //
// ./src/documentList/MoreOptions.tsx